export const INCENTIVE_MODAL_DECISION = {
  SHOW: 'show',
  POSTPONE: 'postpone',
  SKIP: 'skip',
}

const DEFAULT_CONTEXT = {
  isLibModal: true,
  isPhotoGalleryOpen: false,
  formInteracted: false,
  sendProposalFormInteracted: false,
  hasClickedSeePhone: false,
  hasOpenedVideoCall: false,
  isVideoCallModalOpen: false,
  hasClickedReportAdvert: false,
  showModalReport: false,
  showAdReportsLimit: false,
  modalShownThisSession: false,
  isFinancingFormInViewport: false,
}

export function getIncentiveModalDecision(context = {}) {
  const ctx = { ...DEFAULT_CONTEXT, ...context }

  if (!ctx.isLibModal) return INCENTIVE_MODAL_DECISION.SHOW

  // Covers both the photo gallery modal and the 360 gallery overlay.
  if (ctx.isPhotoGalleryOpen) return INCENTIVE_MODAL_DECISION.POSTPONE

  // Do not skip when the send-proposal form is in the viewport: on desktop it
  // lives in the sticky right column and would hide the modal on every visit.
  if (
    ctx.formInteracted ||
    ctx.sendProposalFormInteracted ||
    ctx.hasClickedSeePhone ||
    ctx.hasOpenedVideoCall ||
    ctx.isVideoCallModalOpen ||
    ctx.hasClickedReportAdvert ||
    ctx.showModalReport ||
    ctx.showAdReportsLimit ||
    ctx.modalShownThisSession ||
    ctx.isFinancingFormInViewport
  ) {
    return INCENTIVE_MODAL_DECISION.SKIP
  }

  return INCENTIVE_MODAL_DECISION.SHOW
}
